import { LocationId } from '../location';
import { ApiRoute, HttpMethod } from '../common';
import { FitwareMemberEngagerStatsForLocation } from './FitwareMemberEngagerStats';

export interface GetStatsParams {
    location_id: LocationId;
}

export interface GetStatsQuery {
    startDate: Date;
    endDate: Date;
}

export const StatsApi = {
    getFitwareMemberEngagerStats: new ApiRoute<
        FitwareMemberEngagerStatsForLocation,
        GetStatsParams,
        void,
        GetStatsQuery
    >(HttpMethod.Get, path =>
        path.literal('stats').literal('fitwareMemberEngager').literal('location').param('location_id'),
    ),
};
